module.exports = __webpack_public_path__ + "static/media/Roboto-MediumItalic.cf9744ac.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-MediumItalic.woff
// module id = 523
// module chunks = 0